export default __webpack_public_path__ + "static/media/Paso1.60890ec8.png";